import { registerAction } from '../../Action'

const BEGIN_LOADING_WORKFLOW = 'BEGIN_LOADING_WORKFLOW'

const reducer = (state = {}) => ({
  ...state,
  workflowLoaded: false,
})

const beginLoadingWorkflow = registerAction(BEGIN_LOADING_WORKFLOW, { reducer })

export default beginLoadingWorkflow
